import { useLogin } from "@privy-io/react-auth";
import { useTranslation } from "react-i18next";
import { useRouter } from "@tanstack/react-router";

export default function LoginButton() {
  const { t } = useTranslation();
  const router = useRouter();

  const { login } = useLogin({
    onComplete: () => {
      router.navigate({ to: router.state.location.pathname });
    },
  });

  function handleLogin() {
    login({ loginMethods: ["google", "wallet", "email"] });
  }

  return (
    <>
      <button
        onClick={handleLogin}
        className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-3xl w-[120px]"
      >
        {t("navbar.login")}
      </button>
    </>
  );
}
